<template>
    <div class="container">
        <container :active_path="path" :plate="'云招商'">
            <div class="base-warp">
                <div class="head">
                    <el-form :model="search" ref="form" label-width="80px" :inline="true" size="normal">
                        <el-form-item label="类型">
                            <el-select v-model="search.type" placeholder="类型" size="mini">
                                <el-option :label="item" :value="item" v-for="(item, index) in types" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="区域">
                            <el-select v-model="search.region" placeholder="区域" size="mini">
                                <el-option :label="item.name" :value="item.name" v-for="(item, index) in regions" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="价格">
                            <el-select v-model="search.price" placeholder="价格" size="mini">
                                <el-option :label="item" :value="item" v-for="(item, index) in prices" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="名称">
                            <el-input v-model="search.keyword" size="mini" placeholder="请输入项目名称"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="mini" @click="confirm">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table :data="tabledata" 
                    border 
                    stripe 
                    size="small"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column label="序号" type="index" width="60"></el-table-column>
                        <el-table-column label="类型" prop="type">
                            <template slot-scope="scope">
                                {{scope.row.type}}/{{scope.row.mold}}
                            </template>
                        </el-table-column>
                        <el-table-column label="名称" prop="name" show-overflow-tooltip></el-table-column>
                        <el-table-column label="用户" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{scope.row.user.uname}}/{{scope.row.user.telephone}}
                            </template>
                        </el-table-column>
                        <el-table-column label="区域" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{scope.row.region}}
                            </template>
                        </el-table-column>
                        <el-table-column label="地址" width="200" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{scope.row.location?JSON.parse(scope.row.location).address:''}}
                            </template>
                        </el-table-column>
                        <el-table-column label="价格" align="center">
                            <template slot-scope="scope">
                                {{scope.row.price}}{{scope.row.priceunit}}
                            </template>
                        </el-table-column>
                        <el-table-column label="面积" align="center">
                            <template slot-scope="scope">
                                {{scope.row.coveredarea}}㎡
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" align="center">
                            <template slot-scope="scope">
                                <p class="status text-success" v-if="scope.row.putaway===true">已上架</p>
                                <p class="status text-warning" v-else>已下架</p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>
        <router-view></router-view>
    </div>
</template>

<script>
import container from "../../../components/container"
import baseRegion from '../../../units/region';
export default {
    components: {
        container,
    },
    data() {
        return {
            path: '/attract/houseinfo',
            search: {
                type: '',
                region: '',
                price: '',
                keyword: '',
                status: '',
            },
            pageNo: 1,
            pagesize: 14,
            types: ['全部', '商铺', '写字楼', '工业园', '厂房', '其他'],
            prices: ['价格不限', '20/㎡以下', '20-40/㎡', '40-60/㎡', '60-80/㎡', '80-100/㎡', '100/㎡以上'],
            regions: [],
            tabledata: [],
            total: 0,
        }
    },
    mounted () {
        var regions = baseRegion.wuhan;
		regions.unshift({name: '不限'});
        this.regions = regions;
        this.getproject();
    },
    methods: {
        confirm() {
            this.pageNo = 1;
            this.getproject();
        },
        currentChange(page) {
            this.pageNo = page;
            this.getproject();
        },
        getproject() {
            var params = {
                pageNo: this.pageNo,
                pagesize: this.pagesize,
                region: this.search.region||'',
                price: this.search.price||'',
                keyword: this.search.keyword||'',
                type: this.search.type||'',
                status: this.search.status||'',
            }
            this.$api.gethouselistvsproduct(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (from.path == "/attract/project/detail"){
            this.getproject();
        }
        next();
    },
}
</script>

<style lang="scss" scoped>
</style>